const measurementId = process.env.GATSBY_GA_MEASUREMENT_ID
const isValidMeasurementId = /^G-[A-Z0-9]+$/.test(measurementId || "")
const isAnalyticsEnabled =
  process.env.NODE_ENV === "production" && isValidMeasurementId

let isInitialized = false
let pendingPageViewAnimationFrameId = null

const initializeGoogleAnalytics = () => {
  if (isInitialized || !isAnalyticsEnabled) {
    return
  }

  window.dataLayer = window.dataLayer || []
  window.gtag = function () {
    window.dataLayer.push(arguments)
  }

  window.gtag("js", new Date())
  window.gtag("config", measurementId, {
    send_page_view: false
  })

  const script = document.createElement("script")
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`
  document.head.appendChild(script)

  isInitialized = true
}

exports.onRouteUpdate = ({ location }) => {
  if (!isAnalyticsEnabled) {
    return
  }

  initializeGoogleAnalytics()

  if (pendingPageViewAnimationFrameId !== null) {
    window.cancelAnimationFrame(pendingPageViewAnimationFrameId)
  }

  pendingPageViewAnimationFrameId = window.requestAnimationFrame(() => {
    pendingPageViewAnimationFrameId = window.requestAnimationFrame(() => {
      pendingPageViewAnimationFrameId = null
      window.gtag("event", "page_view", {
        page_location: window.location.href,
        page_path: `${location.pathname}${location.search}${location.hash}`,
        page_title: document.title
      })
    })
  })
}
